<template>
    <div>
        <div class="app-title">
            <div>
                <h2>{{$t('tlt.user.add')}}</h2>
                <ul class="app-breadcrumb breadcrumb">
                    <li class="breadcrumb-item"><router-link to="/"><i class="fa fa-home"></i></router-link></li>
                    <!-- <li class="breadcrumb-item"><router-link to="/adm"><span>{{$t('tlt.administration')}}</span></router-link></li> -->
                    <li class="breadcrumb-item"><router-link to="/adm/userSetting"><span>{{$t('tlt.user')}}</span></router-link></li>
                    <li class="breadcrumb-item"><router-link to="/adm/userSetting/edit"><span>{{$t('tlt.user.add')}}</span></router-link></li>
                </ul>
            </div>
            <div class="col-lg-4">
                <div class="float-lg-right">
                    <button class="btn btn-outline-secondary mr-1" type="button" v-on:click="MMFbackToList('userSetting')"><i
                            class="fa fa-fw fa-lg fa-minus-circle"></i><span
                            class=text>{{$t('btn.basic.cancel')}}</span></button>
                    <button class="btn btn-primary" type="button" v-on:click="MMFSave('userSetting')"><i
                            class="fa fa-fw fa-lg fa-save"></i><span class=text>{{$t('btn.basic.save')}}</span></button>
                </div>
            </div>
        </div>
        <section class="app-content">
            <form>
                <div class="card">
                    <div class="card-body">
                        <div class="row">
                            <div style="display:none;">
                                <input class="form-control" v-model="keycloakId" type="text" value="123">                            
                            </div>
                            <div class="form-group col-md-2">
                                <label class="control-label"><span class="lbl-obg">*</span>{{$t('lbl.user.name')}}:</label>
                                <input 
                                v-validate="'required'"
                                name="name"
                                :class="{'form-control form-control-sm': true, 'is-invalid': errors.has('name') }"
                                v-model="name" type="text" v-bind:disabled="id!=null">
                               <span v-show="errors.has('name')" class="lbl-obg">
                                    {{ errors.first('name') }}
                                </span>
                            </div>
                            <div class="form-group col-md-2">
                                <label class="control-label"><span class="lbl-obg"></span>{{$t('lbl.user.mobile')}}:</label>
                                <input class="form-control" v-model="mobile" type="text">                          
                            </div>
                            <div class="form-group col-md-2">
                                <label class="control-label"><span class="lbl-obg"></span>{{$t('lbl.user.mail')}}:</label>
                                <input class="form-control" v-model="mail" type="text">                            
                            </div>                     
                        </div>                     
                    </div>
                </div>
            </form>
            <div class="card" style="margin-top:20px">
                <div class="card-body">
                    <div class="row" :key="index" v-for="(item,index) in roles">
                        <div class="col-md-2">
                            <label class="control-label"><span class="lbl-obg">*</span>{{$t('tlt.role.list')}}:</label>
                            <dimsearch :entity="roleList" v-model="item.roleName" submitProp="roleName" bindProp="roleName" :bindId="'role'+index"></dimsearch>
                        </div>
                        <div class="col-md-2">
                            <label class="control-label"><span class="lbl-obg">*</span>{{$t('lbl.user.departmentName')}}:</label>
                            <dimsearch validate='required' :entity="locations" v-model="item.locationName" submitProp="locName" bindProp="locName" :bindId="'roleAdd'+index"></dimsearch>
                        </div>
                        <div class="col-md-2">
                            <label class="control-label"><span class="lbl-obg">*</span>{{$t('lbl.user.departmentCode')}}:</label>
                            <dimsearch validate='required' :entity="locations" v-model="item.location" submitProp="id" bindProp="code" :bindId="'roleAdd'+index"></dimsearch>
                        </div>
                        <div class="col-md-1">
                            <label class="control-label"><span class="lbl-obg" style="color:white">1</span></label>
                            <div>
                                <b-button v-if="roles.length!=1" class="btn btn-danger" @click="deleteOne(index)">删除</b-button>
                                <b-button v-if="(index+1)==roles.length" class="btn btn-warning" @click="addNew()">添加</b-button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>      
        </section>
    </div>
</template>

<script>
import {
    createHelpers
} from 'vuex-map-fields';
import {
    mapActions,
    mapState
} from "vuex";

import {   fields } from "@/model/adm/UserSetting";
import dimsearch from "@/components/MMFDimSearch"
const {
    mapFields
} = createHelpers({
    getterType: 'userSetting/getField',
    mutationType: 'userSetting/updateField',
});
export default {
    name: 'sendingEdit',

    data() {
        return {
            roleList: [],
            locations: []
        }
    },
    components: {
        dimsearch
    },
    computed: {
        ...mapFields(fields),
        ...mapState({

        }),
    },
    methods: {
        ...mapActions("base", ["MMFbackToList", "MMFSave"]),
        addNew() {
            var ob = {
                roleName: '',
                location: '',
                locationName: '',
            }
            this.roles.push(ob);
        },
        deleteOne(index) {
            // let state = this.$store.state.dimSearch.bindedStatus
            // for(index; index < this.roles.length-1; index++) 
            // this.$store.dispatch("dimSearch/initBind",{ [`roleAdd${index}`]:state[`roleAdd${index+1}`]})
            // this.$store.dispatch("dimSearch/deleteProp", `roleAdd${index}`)
            // this.roles.splice(index, 1);
            const context = this.$store;
            context.commit("userSetting/deleteRole",index);
        }
    },
    created() {
        this.$store.dispatch("api/get", {
                url: this.$store.state.location.baseModuleUrl + "/location/findAll"
            }, {
                root: true
            })
            .then(data => {
                this.locations = data;
            }),
            this.$store.dispatch("api/get", {
                url: this.$store.state.role.baseModuleUrl + "/role/findAll"
            }, {
                root: true
            })
            .then(data => {
                this.roleList = data;
            })

    },
};
</script>
